import React from 'react';
import { Helmet } from 'react-helmet-async';

const Refund = () => {
  return (
    <>
      <Helmet>
        <title>Refund & Cancellation - Attain Domains</title>
        <meta
          name="description"
          content="Read Attain Domains refund and cancellation policy. Understand our terms for domain purchases through a trusted payment provider."
        />
      </Helmet>

      <main className="container mx-auto max-w-3xl py-10">
        <h1 className="text-2xl font-semibold">Refund & Cancellation</h1>
        <p className="mt-2 text-muted-foreground">
          Last updated: {new Date().toISOString().slice(0, 10)}
        </p>

        <section className="prose dark:prose-invert mt-6 space-y-6">
          <div>
            <h2 className="text-xl font-semibold mb-3">Refunds</h2>
            <p className="text-muted-foreground">
              Due to the nature of digital domain transfers, purchases are generally final once
              escrow is funded.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-3">Cancellations</h2>
            <p className="text-muted-foreground">
              If a transfer cannot be completed, I'll coordinate with the payment provider
              for a resolution.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-3">Questions</h2>
            <p className="text-muted-foreground">
              Contact support@attaindomains.com before purchase if you need clarification.
            </p>
          </div>
        </section>
      </main>
    </>
  );
};

export default Refund;
